












































































import { Dictionary } from "lodash";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ACTION } from ".";
import {
  ApiMessage,
  MailModel,
  MailsApi,
  PostMailRequest,
  PutMailRequest,
} from "../../../apis";

@Component({ components: { ValidationProvider, ValidationObserver } })
export default class AddEditEmailDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({}) mode: ACTION;
  @Prop({ default: {} }) selectedMail: MailModel | { [k: string]: any };
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  notifies: boolean[];
  emailAddress = "";
  postMailRequest: PostMailRequest = {} as any;
  putMailRequest: PutMailRequest = {} as any;

  get show() {
    this.notifies = [false, false, false];
    return this.value;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get editMode() {
    return this.mode === ACTION.EDIT_EMAIL;
  }
  get newMode() {
    return this.mode === ACTION.NEW_EMAIL;
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  async onSubmit() {
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }

    this.$util.showLoading();
    try {
      if (this.mode === ACTION.NEW_EMAIL) {
        await new MailsApi().createMail({
          postMailRequest: {
            emailAddress: this.selectedMail.emailAddress,
            isTreatmentNotification: this.notifies[0],
            isTimeNotification: this.notifies[1],
            isAlarmNotification: this.notifies[2],
            location: this.$route.params.id,
          },
        });
      }

      if (this.mode === ACTION.EDIT_EMAIL) {
        await new MailsApi().updateMail({
          id: this.selectedMail.id,
          putMailRequest: {
            id: this.selectedMail.id,
            emailAddress: this.selectedMail.emailAddress,
            isTreatmentNotification: this.notifies[0],
            isTimeNotification: this.notifies[1],
            isAlarmNotification: this.notifies[2],
            location: this.$route.params.id,
          },
        });
      }
      this.show = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onShow() {
    if (this.mode === ACTION.EDIT_EMAIL && this.selectedMail) {
      this.notifies[0] = this.selectedMail.isTreatmentNotification || false;
      this.notifies[1] = this.selectedMail.isTimeNotification || false;
      this.notifies[2] = this.selectedMail.isAlarmNotification || false;
    }
  }
}
